import { profile_types } from "../../../../core/components/common/variables/static_variables";
import { useRBACStore } from "../../zustand/useRBACStore";

export const getPrefixRouteDashboard = (api_endpoint) => {
    const { userType } = useRBACStore.getState();
    let prefixRoute = api_endpoint;

    if (userType === profile_types.PORT_EMPLOYEE) {
        prefixRoute += '/all';
    }

    if (userType === profile_types.BUSINESS) {
        prefixRoute += '/org';
    }

    if (userType === profile_types.INDIVIDUAL) {
        prefixRoute += '/assigned';
    }

    return prefixRoute;
};